import axios from 'axios';
import Cookies from "universal-cookie";

import {host} from "./../utils";
const cookies = new Cookies();

export default axios.create({
    baseURL: `${host}/api/token`,
    headers: {
        'Accept':'application/json',
        'Content-Type':'application/json',
        "X-CSRFToken": cookies.get("csrftoken"),
    },
    credentials: "same-origin"
})